import type { WeekForecast } from '../../api/weeklyCosts'
import { showPastDueReminderRow, verdictHeadline } from './sorenWeekVerdictHeadline.js'

export default function SorenWeekVerdictCard({
  forecast,
  onEditCosts,
}: {
  forecast: WeekForecast
  onEditCosts?: () => void
}) {
  const isCovered = forecast.verdict_state === 'covered'
  const headline = verdictHeadline(forecast)
  const lateAction = forecast.primary_action?.kind === 'late' ? forecast.primary_action : null
  const showReminder = showPastDueReminderRow(forecast)

  return (
    <div className="soren-week-verdict" data-testid="soren-week-verdict">
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <div style={{ flex: 1, background: '#f9fafb', borderRadius: 8, padding: 12 }}>
          <div style={{ fontSize: 12, color: '#6b7280' }}>Likely in</div>
          <div style={{ fontSize: 20, fontWeight: 600, color: '#047857', marginTop: 2 }}>{forecast.likely_in}</div>
          {forecast.likely_in_note ? (
            <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{forecast.likely_in_note}</div>
          ) : null}
        </div>
        <div style={{ flex: 1, background: '#f9fafb', borderRadius: 8, padding: 12 }}>
          <div style={{ fontSize: 12, color: '#6b7280' }}>Going out</div>
          <div style={{ fontSize: 20, fontWeight: 600, color: '#b91c1c', marginTop: 2 }}>−{forecast.going_out}</div>
          {forecast.going_out_breakdown ? (
            <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{forecast.going_out_breakdown}</div>
          ) : null}
        </div>
      </div>

      <div
        data-testid="soren-week-verdict-pill"
        style={{
          display: 'inline-block',
          background: forecast.verdict_bg || '#f3f4f6',
          color: forecast.verdict_fg || '#6b7280',
          fontSize: 12,
          fontWeight: 600,
          padding: '4px 10px',
          borderRadius: 8,
          marginBottom: 8,
        }}
      >
        {headline}
      </div>

      {forecast.verdict_sentence ? (
        <p style={{ margin: '0 0 12px', fontSize: 13, color: '#4b5563', lineHeight: 1.4 }}>{forecast.verdict_sentence}</p>
      ) : null}

      {showReminder && forecast.reminder_url ? (
        <div
          data-testid="soren-week-verdict-reminder-row"
          style={{
            background: '#fef2f2',
            borderRadius: 10,
            padding: '14px 16px',
            marginBottom: 12,
          }}
        >
          {lateAction ? (
            <>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#b91c1c' }}>{lateAction.title}</div>
              <div style={{ fontSize: 12, marginTop: 2, color: '#b91c1c' }}>{lateAction.subtitle}</div>
            </>
          ) : (
            <div style={{ fontSize: 14, fontWeight: 600, color: '#b91c1c' }}>Largest past-due pay app</div>
          )}
          <a
            href={forecast.reminder_url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            data-testid="soren-week-verdict-reminder"
            style={{ display: 'inline-block', textDecoration: 'none', fontSize: 13, marginTop: 10 }}
          >
            {lateAction?.cta || 'Send reminder'}
          </a>
          <span style={{ display: 'block', fontSize: 11, color: 'var(--ink4)', marginTop: 4 }}>Opens preview — nothing sends until you confirm.</span>
        </div>
      ) : null}

      {isCovered && forecast.primary_action && forecast.primary_action.kind !== 'late' ? (
        <div
          data-testid="soren-week-verdict-action"
          style={{
            background: '#fffbeb',
            borderRadius: 10,
            padding: '14px 16px',
            marginBottom: 12,
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 600 }}>{forecast.primary_action.title}</div>
          <div style={{ fontSize: 12, marginTop: 2, color: 'var(--ink4)' }}>{forecast.primary_action.subtitle}</div>
          {forecast.primary_action.cta && forecast.primary_action.url ? (
            <a
              href={forecast.primary_action.url}
              className="btn btn-ghost"
              style={{ marginTop: 10, display: 'inline-block', fontSize: 13 }}
            >
              {forecast.primary_action.cta}
            </a>
          ) : null}
        </div>
      ) : null}

      {onEditCosts ? (
        <button
          type="button"
          className="btn btn-ghost"
          onClick={onEditCosts}
          data-testid="soren-costs-edit"
          style={{ fontSize: 13, padding: 0 }}
        >
          Edit costs
        </button>
      ) : null}
    </div>
  )
}
